import React from "react";
import { Config } from "../../Config";
import ShowMap from "../ShowMap/ShowMap";
import "./HistoryListItem.scss";
import "./Responsive.scss";

const HistoryListItem = ({ data, done, deliveryCode }) => {
  return (
    <div key={data.productId} className="historyListItems mobile">
      <div className="contentWrapper">
        <div className="listItem listName">
          {data.productName}
          {done && <span className="done">پرداخت شده</span>}
        </div>
        <div className="listItem">
          تعداد : <span className="color">{data.productCount}</span>
        </div>
        <div className="listItem">
          نرخ : <span className="color">{data.isApproved ? "دولتی" : "آزاد"}</span>
        </div>
        <div className="listItem">
          واحد : <span className="color">{data.unitTitle}</span>
        </div>
        <div className="listItem">
          قیمت واحد : <span className="color">{Config.separate(data.price)} ریال</span>
        </div>
        <div className="listItem">
          قیمت کل : <span className="color">{Config.separate(data.price * data.productCount)} ریال</span>
        </div>
        <div className="listItem">
          کد تحویل : <span className="color">{deliveryCode}</span>
        </div>
        {data.hasQuotaError ? (
          <div className="listItem">
            پیغام خطای خرید سهمیه : <span className="color red">{data.quotaErrorMessage}</span>
          </div>
        ) : (
          <div className="listItem">
            کد تاییدیه خرید سهمیه : <span className="color">{data.quotaTransCode}</span>
          </div>
        )}
        <div className="listItem">
          صاحب فروشگاه : <span className="color">{data.providerFullname}</span>
        </div>
        <div className="listItem">
          تلفن فروشگاه : <span className="color">{data.providerTelephone}</span>
        </div>
        <div className="listItem">
          آدرس فروشگاه : <span className="color">{data.providerAddress}</span>
        </div>
        <div className="listItem map">
          <ShowMap
            height={200}
            defaultCenter={[parseFloat(data.lat), parseFloat(data.lng)]}
            anchor={[parseFloat(data.lat), parseFloat(data.lng)]}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(HistoryListItem);
